<template>
    <div>
        <b-card style="max-width: 40rem;" class="mb-2">
            <b-overlay :show="loading" rounded="sm">
                <b-card-title>
                    <h4 class="ml-3">Olá,
                        <small>informe a nova senha!</small>
                    </h4>
                </b-card-title>
                <b-card-body v-if="user">
                    <b-row>
                        <b>
                            <b-col v-if="user.distribuidor">
                                <b> Distribuidor: </b> {{ user.distribuidor.codigo }} - {{ user.distribuidor.nome }}
                            </b-col>
                            <b-col v-else>
                                {{ user.name }}
                            </b-col>
                        </b>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            {{ user.email }}
                        </b-col>
                    </b-row>
                    <b-form @submit.prevent="salvar" class="mt-3">
                        <b-row>
                            <b-col sm="12">
                                <b-form-group id="input-group-1" label="Nova Senha" label-for="password">
                                    <b-form-input id="password" type="password" v-model="password" required
                                        :state="validation">
                                    </b-form-input>
                                    <b-form-invalid-feedback :state="validation">
                                        {{ passwordError }}
                                    </b-form-invalid-feedback>
                                    <b-form-valid-feedback :state="validation">
                                        Senha Válida
                                    </b-form-valid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group id="input-group-1" label="Confirme a Senha" label-for="confirm">
                                    <b-form-input id="confirm" type="password" v-model="confirm" required
                                        :state="validationConfirm">
                                    </b-form-input>
                                    <b-form-invalid-feedback :state="validationConfirm">
                                        {{ passwordError }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col>
                                <b-button size="sm" variant="primary" type="submit">salvar</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card-body>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: "",
            confirm: "",
            user: null,
            token: "",
            loading: false,
            passwordError: ""
        }
    },

    mounted() {
        this.user = JSON.parse(document.getElementById('user').value);
        this.token = document.getElementById('token').value;

    },

    computed: {
        validationConfirm() {
            return this.password !== '' && this.password == this.confirm
        },
        validation() {
            const rules = [
                { test: /.{8,}/, message: "A senha deve ter pelo menos 8 caracteres." },
                { test: /[A-z]/, message: "A senha deve ter pelo menos uma letra." },
                { test: /[0-9]/, message: "A senha deve ter pelo menos um número." }
                //{ test: /[@$!%*?&#]/, message: "A senha deve ter pelo menos um caractere especial." },
            ];
            for (const rule of rules) {
                if (!rule.test.test(this.password)) {
                    this.passwordError = rule.message;
                    return false;
                }
            }
            this.passwordError = "";
            return true;
        }
    },
    methods: {
        salvar() {
            const vm = this;
            if (!this.validation) {
                return vm.$swal({
                    title: "Atenção",
                    text: "A nova senha não atende aos requisitos mínimos de senha",
                    icon: "error",
                });
            }
            if (!this.validationConfirm) {
                return vm.$swal({
                    title: "Atenção",
                    text: "A confirmação de senha é diferente da nova senha",
                    icon: "error",
                });
            }
            const data = {
                password: this.password,
                confirm: this.confirm,
                email: this.user.email,
                recover: true
            }

            vm.loading = true
            axios.post('/password/reset/' + this.token, data)
                .then((response) => {
                    window.location.href = "/";
                }).catch((error) => {
                    console.log(error)
                    vm.$swal({
                        title: "Atenção",
                        text: "Erro ao alterar senha",
                        icon: "error",
                    });
                }).finally(() => {
                    vm.loading = false
                })
        },
    }
}

</script>

<style>
button {
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

button:hover {
    background-color: #45a049;
    box-shadow: black;
}

span {
    color: red;
}


@media (max-width: 1000px) {
    .logo {
        display: none;
    }

    .title {
        text-align: justify;
        font-size: 18px;
    }

    .distribuidor {
        text-align: center;
        font-size: 20;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/util/RememberReset.vue